module.exports = "/static/assets/08ec0a98517212b26bd0c4109cb5b08c.png";